import { ReactNode } from 'react';

/** Marca o título de cada etapa: é para onde o foco vai quando a etapa troca (REC-04). */
export const STEP_HEADING_ATTRIBUTE = 'data-step-heading';

/** `tabIndex={-1}`: o título recebe o foco por código, sem entrar na ordem de tabulação. */
export const HEADING_FOCUS_PROPS = { [STEP_HEADING_ATTRIBUTE]: true, tabIndex: -1 };

/** Título da etapa. Recebe o foco na troca de etapa, por isso `tabIndex={-1}`. */
export function StepHeading({ children, hidden = false }: { children: ReactNode; hidden?: boolean }) {
  return (
    <h3
      {...HEADING_FOCUS_PROPS}
      className={
        hidden
          ? 'screen-reader-text'
          : 'm-0 text-sm font-normal leading-snug text-content outline-none [text-wrap:pretty] focus-visible:underline'
      }
    >
      {children}
    </h3>
  );
}

/** Destaque dentro do título: o nome do colega, o tipo, o comportamento. Azul-escuro pelo contraste. */
export function Emphasis({ children }: { children: ReactNode }) {
  return <b className="font-bold text-brand-blue-dark">{children}</b>;
}

/** Bloco rosa que agrupa as opções de uma etapa. */
export function StepPanel({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`flex flex-col gap-3.5 rounded-jj-lg bg-brand-pink-light p-3.5 sm:p-[18px] ${className}`}>{children}</div>
  );
}

/**
 * Ações presas ao pé do corpo da modal (`sticky`): numa tela mais alta que o cartão, como a da
 * mensagem no celular, a ação principal segue à mão sem rolar até o fim. Quando o conteúdo cabe,
 * ficam onde o design as põe, logo abaixo dele. As margens negativas desfazem o recuo lateral do
 * corpo da modal, para a faixa branca cobrir a largura toda; no celular uma linha a separa do
 * conteúdo que passa por trás.
 */
export function ActionBar({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={`sticky bottom-0 z-10 -mx-4 flex flex-wrap items-center justify-center gap-x-3.5 gap-y-2 self-stretch border-t border-surface-200 bg-brand-white px-4 py-3 sm:-mx-8 sm:border-t-0 sm:px-8 ${className}`}
    >
      {children}
    </div>
  );
}
